<script>
import base from '@/views/config/addon-cards/templates/base.vue';
import {AUDIO_SUB_TYPES, BILLING_CYCLE, planTypes} from '@/common/constants';
import { isZoomMeetingAsAddonCard } from '@/plans/ZOOM_MEETING/common/utils';
import computedMixins from './mixins/computed-mixins';
import AudioConferencingIcon from '@/assets/plans/audio_conferencing.svg';
import { mapGetters } from 'vuex';

export default {
  name: 'AudioAddonCard',
  mixins: [base, computedMixins],
  for: ()=> {
      const shouldHide = isZoomMeetingAsAddonCard();
      if(shouldHide) return [];
      return planTypes.map([planTypes.ZOOM_MEETING, planTypes.ZOOM_ONE_BUNDLE, planTypes.VIDEO_SDK, planTypes.ZONE_PRO_PLUS, planTypes.ZONE_EDU_PLUS]);
  },
  computed: {
    ...mapGetters(['getCurrentBasePlanInfo']),
    isSDKAudio() {
      return this.getCurrentBasePlanInfo.planType === planTypes.VIDEO_SDK;
    },
    currentProductPlans() {
      return [this.mx_getAudioPlans.find(item => item.category === AUDIO_SUB_TYPES.TOLL_FREE && item.billing_cycle === BILLING_CYCLE.MONTHLY)];
    }
  },
  data() {
    return {
      logo: AudioConferencingIcon,
      title: '',
      subtitle: '',
      description: '',
      planType: planTypes.TOLLFREE,
    };
  },
  created() {
    const { amount } = this.mx_monthlyAudio;
    this.logo = AudioConferencingIcon;
    this.title = this.$t('billing.tollfree.audio_conferencing.title');
    this.subtitle = this.$t('billing.common.form_xx_month', [this.$money(amount)]);
    this.productPlans = this.currentProductPlans;
    this.description = this.$t('billing.tollfree.audio_addon_desc');
    if(this.isSDKAudio) {
      this.description = this.$t('billing.tollfree.desc_for_sdk');
    }
  },
};
</script>
